import {
    HttpResponse,
    TargetModel,
    QueryModel,
    RequestParams,
    TargetModelIEnumerableApiResultSuccess,
    TargetModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class TargetsDataService implements CrudService<TargetModel, TargetModel> {
    getAll(query: CrudDataQuery<TargetModel>): Promise<CrudEnumerableResponse<TargetModel>> {
        return ApiService.api.getTargetBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<TargetModel>): Promise<CrudEnumerableResponse<TargetModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<TargetModel>> {
        return ApiService.api.getTargetById(id, params);
    }

    create(item: TargetModel, params?: RequestParams): Promise<CrudResponse<TargetModel>> {
        return ApiService.api.insertTarget(item, params);
    }

    update(item: TargetModel, params?: RequestParams): Promise<TargetModel> {
        return ApiService.api.updateTarget(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<TargetModel> {
        return ApiService.api.patchTarget(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<TargetModel>): Promise<CrudEnumerableResponse<TargetModel>> {
        return ApiService.api.deleteTargets(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationTarget(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<TargetModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: TargetModel, params?: RequestParams): Promise<CrudResponse<TargetModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getTargetGroupped(query, params);
    }

}
